import * as React from 'react';
import { BaSeDataSelectionContext } from '../../../contexts/data/selection';
import { BaSeIcon } from '../../image/icon';
import { BaSeCheckbox } from '../../input/checkbox/checkbox';
import { DataInterfaceProps } from '../data-styled';

export interface ToggleRowCheckboxProps<Item>
  extends Pick<DataInterfaceProps, 'highlightedColor'> {
  rowItem: Item;
  rowIdKey: keyof Item;
}

export function DataToggleRowCheckbox<Item extends object>({
  highlightedColor,
  rowIdKey,
  rowItem,
}: React.PropsWithoutRef<ToggleRowCheckboxProps<Item>>): JSX.Element {
  const { isAllSelected, selectedItems, setSelectedItems } = React.useContext(
    BaSeDataSelectionContext,
  );

  const rowSelected = React.useMemo(
    () =>
      isAllSelected ||
      selectedItems.some((item) => rowItem[rowIdKey] === item[rowIdKey]),
    [isAllSelected, selectedItems],
  );

  return isAllSelected ? (
    <BaSeIcon
      name="check"
      description="asd"
      color={highlightedColor as string}
      size={28}
    />
  ) : (
    <BaSeCheckbox
      color={highlightedColor}
      checked={rowSelected}
      onChange={(changedChecked) => {
        setSelectedItems((actual) =>
          actual.filter((item) => rowItem[rowIdKey] !== item[rowIdKey]),
        );
        if (changedChecked) {
          setSelectedItems((actual) => [...actual, rowItem]);
        }
      }}
    />
  );
}
